import { render } from "./marginManagement.vue?vue&type=template&id=8914f1ee&scoped=true"
import script from "./marginManagement.vue?vue&type=script&lang=js"
export * from "./marginManagement.vue?vue&type=script&lang=js"

import "./marginManagement.vue?vue&type=style&index=0&id=8914f1ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8914f1ee"]])

export default __exports__